"use strict";

exports.__esModule = true;
exports.JOBS = exports.OPEN_SOURCE = exports.PROJECTS = exports.ARTICLES = exports.WORKSHOPCOMPANIES = exports.WORKSHOPS = exports.HOME = void 0;
var HOME = '/';
exports.HOME = HOME;
var WORKSHOPS = '/workshops';
exports.WORKSHOPS = WORKSHOPS;
var WORKSHOPCOMPANIES = '/companiesworkshop';
exports.WORKSHOPCOMPANIES = WORKSHOPCOMPANIES;
var ARTICLES = '/articles';
exports.ARTICLES = ARTICLES;
var PROJECTS = '/projects';
exports.PROJECTS = PROJECTS;
var OPEN_SOURCE = '/open-source';
exports.OPEN_SOURCE = OPEN_SOURCE;
var JOBS = '/jobs';
exports.JOBS = JOBS;